module.exports = function _isNumber(x) {
  return Object.prototype.toString.call(x) === '[object Number]';
};



/*****************
 ** WEBPACK FOOTER
 ** ./~/ramda/src/internal/_isNumber.js
 ** module id = 1453
 ** module chunks = 0
 **/